import { Quote } from "lucide-react";
import "./index.css";

export default function CEOMessage() {
  return (
    <div className="ceo-message-container">
      <div className="hero-section">
        <div className="">
          <h1 className="hero-title">MESSAGE FROM THE CEO</h1>
        </div>
      </div>

      <div className="content-section">
        <div className="ceo-profile">
          <div className="ceo-image-container">
            {/* <img
              src="/img/MUHAMMAD-HAMMAD-ARSHAD-300x300.jpg"
              alt="CEO Name"
              className="ceo-image"
            /> */}
          </div>
          <div className="ceo-info">
            <h2 className="ceo-name">MUHAMMAD HAMMAD ARSHAD</h2>
            <h3 className="ceo-position">Chief Executive Officer</h3>
          </div>
        </div>

        <div className="message-content">
          <Quote className="quote-icon" size={48} />
          <p className="message-text">Dear Valued Stakeholders,</p>
          <p className="message-text">
            Our vision at Orbit Securities Private Limited (OSPL) is to become
            Pakistan’s preferred stock market broker. We are committed to
            providing you, our clients, with the optimal environment to enhance
            your trading experience and boost your performance.
          </p>
          <p className="message-text">
            We strive to provide our valued clients with actionable ideas. As a
            client of OSPL, your decision to trade with us entitles you to the
            best trading conditions at all times. We constantly deliver
            top-quality services including execution, settlement, research, and
            risk management to enhance your trading experience.
          </p>
          <p className="message-text">
            As a capital market player, you need to have confidence in your
            broker and access to value-adding market insight to protect and grow
            your investment. OSPL fully meets these requirements. We have
            valuable brand equity in the local market that has been recognized
            by our valued clients{" "}
          </p>
          <p className="message-text">
            At OSPL, we adhere to the saying by Mian Hammad “People of
            accomplishment rarely sit back and let things happen to them. They
            so out and make thing happen” As testament to this statement, Retail
            clients are serviced through OSPL Trade, Pakistan’s efficient online
            trading platform. A professional in-house research team provides
            premium fundamental and technical analysis to trade our clients’ in
            their decision-making process.
          </p>
          <p className="message-text">
            At OSPL, we adhere to the saying by Mian Hammad “People of
            accomplishment rarely sit back and let things happen to them. They
            so out and make thing happen” As testament to this statement, Retail
            clients are serviced through OSPL Trade, Pakistan’s efficient online
            trading platform. A professional in-house research team provides
            premium fundamental and technical analysis to trade our clients’ in
            their decision-making process.
          </p>
          <p className="message-text">
            I invite you to browse our website and discover who we are and learn
            more fully how OSPL can advance your investment and business needs.
            In this spirit, thank you for selecting OSPL company as your broker
            of choice and all the best in your future trading.
          </p>

          <div className="signature">
            <p className="signature-name">MUHAMMAD HAMMAD ARSHAD</p>
            <p className="signature-position">Chief Executive Officer</p>
          </div>
        </div>
      </div>
    </div>
  );
}
